var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.5 7c0 .3-.1.5-.3.7-.4.4-1 .4-1.4 0L7.5 2.4 2.2 7.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l6-6c.4-.4 1-.4 1.4 0l6 6c.2.2.3.4.3.7z"}));
}

ChevronUp.defaultProps = {"viewBox":"0 0 15 8"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
